import * as DeveloperConstant from "../Constants/DeveloperConstant";
import * as PathUtils from "./PathUtils";

export { addOrUpdateQueryParameterToPathString } from "./PathUtils";
export { getSandBoxStatus, getSandBoxTextUrl, isSandBoxAvailable, hasSandboxAccount } from "../../middleware/Utils/DeveloperUtils";

export const getWebClientSandBoxUrl = (stringUrl) => {
    const sandBoxUrl = PathUtils.convertToUrl(stringUrl);
    sandBoxUrl.host = DeveloperConstant.SandBoxWebClientPrefix + sandBoxUrl.host;

    return sandBoxUrl;
}

export const getSandBoxStatusValueToDisplay = (sandBoxstatus) => {
    let statusToDisplay = sandBoxstatus;
    if (sandBoxstatus === DeveloperConstant.SandBoxState.SUCCESS)
        statusToDisplay = "active";

    return statusToDisplay;
}